document.addEventListener('DOMContentLoaded', function() {

	const materialsSection = () => {
		const sections = document.querySelectorAll('.cs-materials');

		if (!sections) {
			return;
		}

		sections.forEach(section => {
			const buttonActiveClass = 'cs-materials__btn--active';
			const panelActiveClass = 'cs-materials__panel--active';
			const buttons = section.querySelectorAll('.cs-materials__btn');
			if (!buttons) {
				return;
			}
			const handlePanels = (button) => {
				const index = button.dataset.index;

				// Close old panel
				const oldPanel = section.querySelector(`.${panelActiveClass}`);
				if (oldPanel) {
					oldPanel.classList.remove(panelActiveClass);
				}

				// Set new panel
				const newPanel = section.querySelector(`.cs-materials__panel[data-index="${index}"]`);
				if (newPanel) {
					newPanel.classList.add(panelActiveClass);
				}

				// Update button class
				const oldButton = section.querySelector(`.${buttonActiveClass}`);
				if (oldButton) {
					oldButton.classList.remove(buttonActiveClass);
				}

				button.classList.add(buttonActiveClass);
			};

			buttons.forEach(button => {
				button.addEventListener('click', () => {
					handlePanels(button);
				}, false);
			})
		});
	}

	materialsSection();

});